/* eslint-disable */
// because legacy

import "jquery-typeahead"
import "@bikemap/js/legacy/lib/jquery.mixitup.js"
import "objectFitPolyfill"
import _forEach from "lodash-es/forEach"

import { createCookie, readCookie } from '@bikemap/js/utility'
import { SEARCH_AUTOCOMPLETE_URL } from '@bikemap/js/settings'

$(function() {
  "use strict"

  window.app = window.app || {}
  $.outdoorish = $.outdoorish || {}

  /** ******************* MixItUp Grid/List view switch *********************/
  // We will be using MixItUp's 'changeLayout' API method to add and remove a 'list' class to the container. This class changes the styling of our target elements (see CSS).
  // NB: Changing layout doesn't have to be between grid/list only, we can add any class we want and use it to affect the styling of our elements.
  // FIXME: id vor view-mode-grid / view-mode-list is not unique if multi tab
  $.outdoorish.initMixItUp = function(controls, container, options, callback) {
    var defaultOptions = {
      animation: {
        animate: true,
        duration: 600,
        effects: "fade",
        reverseOut: true,
        animateChangeLayout: false, // Animate the positions of targets as the layout changes
        animateResizeTargets: false // Animate the width/height of targets as the layout changes
      },
      layout: {
        containerClass: "grid" // Add the class 'grid' to the container on load
      }
    }

    var $container = container

    var $changeLayoutToGrid = $("#view-mode-grid", controls)

    var $changeLayoutToList = $("#view-mode-list", controls)

    var mixItUpOptions = $.extend(defaultOptions, options)

    container.mixItUp(mixItUpOptions)

    // MixItUp does not provide a default "change layout" button, so we need to make our own and bind it with a click handler:
    var layout = mixItUpOptions.layout.containerClass
    $changeLayoutToGrid.off("click").on("click", function() {
      if (layout === "list") {
        layout = "grid"
        $changeLayoutToList.removeClass("view-mode-active")
        $changeLayoutToGrid.addClass("view-mode-active")
        $container.mixItUp(
          "changeLayout",
          {
            containerClass: layout
          },
          true,
          callback
            ? callback.bind({
                layout: layout
              })
            : null
        )
      }
    })

    $changeLayoutToList.off("click").on("click", function() {
      if (layout === "grid") {
        layout = "list"
        $changeLayoutToGrid.removeClass("view-mode-active")
        $changeLayoutToList.addClass("view-mode-active")
        $container.mixItUp(
          "changeLayout",
          {
            containerClass: layout
          },
          true,
          callback
            ? callback.bind({
                layout: layout
              })
            : null
        )
      }
    })
  }

  // Kept this function to avoid merge conflicts
  $.outdoorish.createCookie = function(name, value, days) {
    createCookie(name, value, days)
  }

  $.outdoorish.readCookie = function(name) {
    return readCookie(name)
  }

  $.outdoorish.initAutocomplete = function(field) {
    $(field + "-input").typeahead({
      input: field + "-input", // Node.selector has been removed with jQuery 3.0, so we specify it again
      minLength: 3,
      maxItem: 6,
      blurOnTab: false,
      dynamic: true,
      delay: 300,
      display: ["value", "data.location"],
      template: function(query, item) {
        var template = '<div class="tt-result-name">{{value}}</div>'

        if (item.data.lat && item.data.lng) {
          template =
            '<i class="i-location"></i>' +
            template
          template += '<div class="tt-result-location">{{data.location}}</div>'
        }

        return template
      },
      filter: false,
      source: {
        regions: {
          ajax: {
            url: SEARCH_AUTOCOMPLETE_URL,
            data: {
              q: "{{query}}",
              type: "geonames"
            },
            path: "suggestions"
          }
        }
      },
      callback: {
        onEnter: function(node, a) {
          $(field + "-input").val(a.find(".tt-result-name").text())
        },
        onLeave: function() {
          $(field + "-input").val(this.query)
        },
        onClick: function(node, a, item) {
          $("#id_location").val(item.data.geoname_id)
          $("#id_location_class").val(item.data.geoname_fcode)
        }
      }
    })

    // If the field is populated from the beginning, show the cancel button
    if ($(field + "-input").val()) {
      Typeahead["#location-autocomplete-input"].toggleCancelButtonVisibility()
    }
  }
})
